import {createClientRequestId} from './createClientRequestId';
import { IMAGE_CAPTURE_INTENTS } from '../features/imageCapture/imageCaptureIntent';

export const createQuickCheckInSubmission = () => {
  let inFlight = null;
  let request = null;

  return {
    run(action) {
      if (inFlight) return inFlight;
      inFlight = Promise.resolve().then(action).finally(() => { inFlight = null; });
      return inFlight;
    },
    getRequestId(identity) {
      if (!request || Object.keys(identity).some((key) => identity[key] !== request.identity[key])) {
        request = {
          identity: { ...identity },
          id: createClientRequestId('quicklog'),
        };
      }
      return request.id;
    },
    complete() { request = null; },
  };
};

export const runQuickCheckInPrimaryAction = ({
  hasNoteText, hasAttachedMedia, noteData, isEditMode, photoIntent, photoFile,
  saveVoiceSourceNote, savePhotoSourceNote, saveQuickNote, handleSmartSaveOrCapture,
}) => {
  if (!hasNoteText && !hasAttachedMedia) return;
  if (noteData?.audioBlob && !isEditMode) return saveVoiceSourceNote();
  if ([IMAGE_CAPTURE_INTENTS.READ_TEXT, IMAGE_CAPTURE_INTENTS.SAVE_PHOTO].includes(photoIntent) && photoFile && !noteData?.audioBlob) {
    return savePhotoSourceNote();
  }
  if ((photoIntent === IMAGE_CAPTURE_INTENTS.CARE_DETAILS && photoFile && !noteData?.audioBlob)
    || isEditMode || (hasAttachedMedia && !hasNoteText)) return saveQuickNote();
  return handleSmartSaveOrCapture();
};
